import { default as _91_46_46_46uri_93FmSYeNXvC5Meta } from "/vercel/path0/pages/[...uri].vue?macro=true";
import { default as _91_46_46_46all_93wk4n2GKVSNMeta } from "/vercel/path0/pages/products/[...all].vue?macro=true";
import { default as styleguideHzhu7gdkpRMeta } from "/vercel/path0/pages/styleguide.vue?macro=true";
import { default as component_45stubiiKM56WbrNMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@20.17.6_encoding@0.1.13_eslint@9.15.0_jiti@2._seie66lerq6tctv3lxkuw4wyxe/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubiiKM56WbrN } from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@20.17.6_encoding@0.1.13_eslint@9.15.0_jiti@2._seie66lerq6tctv3lxkuw4wyxe/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "uri___ch_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ch_fr",
    path: "/ch_fr/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ch_it",
    path: "/ch_it/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___ch_en",
    path: "/ch_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___at_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___at_en",
    path: "/at_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___de_de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___de_en",
    path: "/de_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___se_sv",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___se_en",
    path: "/se_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___pl_pl",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___pl_en",
    path: "/pl_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "products-all___ch_de",
    path: "/reinigungsprodukte/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___ch_fr",
    path: "/ch_fr/produits-de-nettoyage/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___ch_it",
    path: "/ch_it/prodotti-per-la-pulizia/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___ch_en",
    path: "/ch_en/cleaning-products/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___at_de",
    path: "/reinigungsprodukte/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___at_en",
    path: "/at_en/cleaning-products/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___de_de",
    path: "/reinigungsprodukte/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___de_en",
    path: "/de_en/cleaning-products/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___se_sv",
    path: "/stadprodukter/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___se_en",
    path: "/se_en/cleaning-products/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___pl_pl",
    path: "/produkty-czyszczace/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "products-all___pl_en",
    path: "/pl_en/cleaning-products/:all(.*)*",
    component: () => import("/vercel/path0/pages/products/[...all].vue")
  },
  {
    name: "styleguide___ch_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ch_fr",
    path: "/ch_fr/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ch_it",
    path: "/ch_it/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___ch_en",
    path: "/ch_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___at_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___at_en",
    path: "/at_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___de_de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___de_en",
    path: "/de_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___se_sv",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___se_en",
    path: "/se_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___pl_pl",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___pl_en",
    path: "/pl_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: component_45stubiiKM56WbrNMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubiiKM56WbrN
  }
]